<template>
  <div class="Dashboard full-height">
    <transition class="full-height">
      <keep-alive :include="$route.meta.include">
        <router-view />
      </keep-alive>
    </transition>

    <van-row
      type="flex"
      align="center"
      class="nav-tabbar shadow"
    >
      <van-col
        v-for="(tab,index) in tabbarList"
        :key="tab.link"
        :span="(tabbarList.length==4?6:((tabbarList.length == 5 && index == 2) ? 4 : 5))"
        @click.native="$router.push(tab.link)"
      >
        <van-badge
          :content="(tab.count > 0 ? tab.count:'')"
          max="99"
        >
          <van-image
            width="24"
            height="24"
            class="normal"
            :src="tab.normalImg"
            v-if="tab.normalImg&&(hashAddr != tab.link)"
          />
          <van-image
            width="24"
            height="24"
            class="active"
            :src="tab.activeImg"
            v-if="tab.activeImg&&(hashAddr == tab.link)"
          />
          <!-- <ld-icon
            :type="tab.normalSvg"
            v-if="tab.activeSvg&&(hashAddr != tab.link)"
          />
          <ld-icon
            class="active font30"
            :name="tab.activeImg"
            v-if="tab.activeSvg&&(hashAddr == tab.link)"
          /> -->
          <!-- <svg
            class="svg-icon font24"
            aria-hidden="true"
            v-if="tab.normalSvg&&(hashAddr != tab.link)"
          >
            <use :xlink:href="`#${tab.normalSvg}`" />
          </svg>
          <svg
            class="svg-icon active font30"
            aria-hidden="true"
            v-if="tab.activeSvg&&(hashAddr == tab.link)"
          >
            <use :xlink:href="`#${tab.activeSvg}`"/>
          </svg> -->
          <div>{{ $t(tab.title) }}</div>
        </van-badge>
      </van-col>
    </van-row>
  </div>
</template>

<script>

import tabbarImg1 from 'Assets/images/home/1df.png'
// import tabbarImg2 from 'Assets/images/home/2df.png'
import tabbarImg3 from 'Assets/images/home/3lt.png'
// import tabbarImg4 from 'Assets/images/home/4df.png'
import tabbarImg1Act from 'Assets/images/home/1lf.png'
// import tabbarImg2Act from 'Assets/images/home/2lf.png'
// import tabbarImg4Act from 'Assets/images/home/4lf.png'
import tabbarImg5 from 'Assets/images/home/5df.png'
import tabbarImg5Act from 'Assets/images/home/5lf.png'

import message from 'Components/Dynamic/qhhk/images/navbar/message.png'
import message1 from 'Components/Dynamic/qhhk/images/navbar/message1.png'
import approval from 'Components/Dynamic/qhhk/images/navbar/approval.png'
import approval1 from 'Components/Dynamic/qhhk/images/navbar/approval1.png'


import { mapGetters } from 'vuex'
import { localget } from 'Utils/storage.js'
import { Image as VanImage , Badge} from 'vant'

export default {
  name: 'Dashboard',
  components:{
    [VanImage.name]: VanImage,
    [Badge.name]: Badge,
  },
  data () {
    return {
      hashAddr: '/home'
    }
  },
  computed: {
    ...mapGetters({
      userInfo:'userInfo',
      badgeDotCount: 'badgeDotCount'
    }),
    tabbarList(){
      let obj=[
        {
          link: '/home',
          title: 'A003',//首页
          normalImg: tabbarImg1,
          activeImg: tabbarImg1Act
        },
        // {
        // 	link: '/allorder',
        // 	title: 'A004',//行程
        // 	normalImg: tabbarImg2,
        // 	activeImg: tabbarImg2Act
        // },
        {
          link: '/userCenter/message',///message
          title: '消息',
          count: this.badgeDotCount && this.badgeDotCount.message,
          normalImg: message,
          activeImg: message1,
        },
        {
          link: '/tripList',
          title: 'A005',//申请
          normalImg: tabbarImg3,
          activeImg: tabbarImg3
        },
        // {
        // 	link: '/approvalList',
        // 	title: 'A006',//审批
        // 	normalImg: tabbarImg4,
        // 	activeImg: tabbarImg4Act
        // },
        {
          link: '/approvalList',
          // query: { index: 3 },
          title: '待办',//审批
          count: this.badgeDotCount && this.badgeDotCount.daibantotal,
          normalImg: approval,
          activeImg: approval1
        },
        {
          link: '/userCenter',
          title: 'A007',//我的
          normalImg:tabbarImg5,
          activeImg:tabbarImg5Act,
        }
      ]
      if(this.userInfo&&this.userInfo.vipCorp){
        if(this.userInfo.vipCorp.bookStyle==1){
          obj.splice(2,1)
          return obj
        }
      }else{
        let userInfo = localget('userInfo')
        if(userInfo){
          this.$store.commit('SET_USERINFO',userInfo)
          //如果是单订模式 删除申请单的入口
          if(userInfo.vipCorp&&userInfo.vipCorp.bookStyle==1){
            obj.splice(2,1)
            return obj
          }
        }
      }
      return obj
    }
  },
  created () {
    if(!this.userInfo||!this.userInfo.vipCorp){
      let userInfo = localget('userInfo')
      if(userInfo){
        this.$store.commit('SET_USERINFO',userInfo)
      }
    }
    this.hashAddr = this.$route.path
  },
  watch: {
    '$route.path': function (val) {
      if(val==='/allOrder?findType=1'){//默认进入订单列表中的 未出行
        this.$store.commit('SET_ORDERLISTPARAMS',{findType:'3'})
      }
      this.hashAddr = val
    }
  }
}
</script>

<style lang="less" scoped>
.Dashboard {
  .nav-tabbar {
    background-color: @color-background-white;
    position: fixed;
    left: 0px;
    bottom: 0px;
    right: 0px;
    height: 50px;
    // border-radius: @border-radius-sm;
    overflow: hidden;
    text-align: center;
    padding: 4px 0;
    line-height: 1;

    .normal {
      height: 26px;
    }
    .active {
      height: 26px;
    }
  }
}
</style>
